// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"26d29dc0","787":"8c88d7b0"}[chunkId] + ".chunk.js";
};